module.exports = __webpack_public_path__ + "static/undraw_order_a_car_3tww_dark-52f51b9fbd5be2400222a1da3a9ff559.svg";